import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import MobileBottomMenu from '../MobileBottomMenu';
import { PhoneIcon, EnvelopeIcon } from '@heroicons/react/24/outline';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { FaFacebookF, FaInstagram } from 'react-icons/fa';
import ScrollToTop from '../ScrollToTop';

export default function Layout({ children }) {
  const location = useLocation();
  React.useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  const [isVisible, setIsVisible] = useState(false);
  const [showBanner, setShowBanner] = useState(true);

  useEffect(() => {
    const consentGiven = localStorage.getItem('cookie-consent');
    if (!consentGiven) {
      setIsVisible(() => true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setIsVisible(() => false);
  };

  const handleReject = () => {
    localStorage.setItem('cookie-consent', 'rejected');
    setIsVisible(() => false);
  };

  return (
    <>
      {showBanner && (
        <div className="relative flex items-center justify-between gap-x-6 bg-gray-700 px-6 py-2.5 sm:pr-3.5 lg:pl-8">
          <div className="flex items-center space-x-6 text-sm text-white">
            <a
              href="tel:+393513631080"
              className="flex items-center gap-x-1 transition hover:text-primary"
            >
              <PhoneIcon className="size-4" />
              <span>+39 351 363 1080</span>
            </a>

            <a
              href="mailto:info@nccbrodriver.it"
              className="hidden items-center gap-x-1 transition hover:text-primary md:flex"
            >
              <EnvelopeIcon className="size-4" />
              <span>info@nccbrodriver.it</span>
            </a>

            <a
              href="https://www.facebook.com/profile.php?id=61550865143574"
              target="_blank"
              rel="noopener noreferrer"
              className="hidden text-white transition hover:text-primary sm:block"
            >
              <FaFacebookF className="size-4" />
            </a>
            <a
              href="https://www.instagram.com/nccbrodriver"
              target="_blank"
              rel="noopener noreferrer"
              className="hidden text-white transition hover:text-primary sm:block"
            >
              <FaInstagram className="size-4" />
            </a>
          </div>
          <button
            type="button"
            onClick={() => setShowBanner(show => !show)}
            className="-m-3 flex-none p-3 focus-visible:-outline-offset-4"
          >
            <span className="sr-only">Dismiss</span>
            <XMarkIcon aria-hidden="true" className="size-5 text-white" />
          </button>
        </div>
      )}

      <Header pathname={location.pathname} />

      <ScrollToTop pathname={location.pathname} />

      <main className="flex-1">
        <>
          {children}
          <div className="fixed bottom-6 right-6 z-50 hidden sm:block">
            <a
              href="https://wa.me/+393513631080"
              target="_blank"
              rel="noopener noreferrer"
              className="flex size-16 items-center justify-center rounded-full bg-green-500 text-white shadow-lg transition duration-300 hover:bg-green-600"
              title="Scrivici su WhatsApp"
            >
              <svg className="size-7" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.04c-5.5 0-9.96 4.46-9.96 9.96 0 1.76.45 3.44 1.3 4.94l-1.36 4.97 5.07-1.33c1.45.77 3.09 1.17 4.75 1.17 5.5 0 9.96-4.46 9.96-9.96S17.5 2.04 12 2.04zm0 18.24c-1.45 0-2.87-.39-4.11-1.14l-.29-.17-3.01.79.8-2.94-.18-.3c-.78-1.29-1.2-2.78-1.2-4.3 0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8zm4.39-5.55c-.24-.12-1.42-.7-1.64-.78-.22-.08-.38-.12-.54.12s-.62.78-.76.94c-.14.16-.28.18-.52.06s-1-.37-1.9-1.19c-.7-.62-1.17-1.38-1.3-1.61-.14-.23-.01-.36.1-.48.1-.1.24-.26.36-.4.12-.14.16-.24.24-.4.08-.16.04-.3-.02-.42s-.54-1.3-.74-1.78c-.2-.48-.4-.42-.54-.42h-.46c-.16 0-.42.06-.64.3s-.84.82-.84 2c0 1.18.86 2.32.98 2.48.12.16 1.69 2.6 4.12 3.64.58.25 1.04.4 1.4.51.59.19 1.13.16 1.56.1.48-.07 1.42-.58 1.62-1.14.2-.55.2-1.02.14-1.12-.06-.1-.22-.16-.46-.28z" />
              </svg>
            </a>
          </div>
          <MobileBottomMenu />
          {isVisible && (
            <div className="pointer-events-none fixed inset-x-0 bottom-0 z-50 px-6 pb-6">
              <div className="pointer-events-auto max-w-xl rounded-xl bg-white p-6 shadow-lg outline outline-1 outline-gray-900/10">
                <p className="text-sm/6 text-gray-900">
                  Questo sito utilizza i cookie per migliorare la tua esperienza. Alcuni cookie sono
                  necessari per il funzionamento del sito, mentre altri sono utilizzati per
                  analizzare l&apos;uso del sito e personalizzare i contenuti. Accetta i cookie per
                  un&apos;esperienza completa.
                </p>
                <div className="mt-4 flex items-center gap-x-5">
                  <button
                    type="button"
                    onClick={handleAccept}
                    className="rounded-md bg-gray-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
                  >
                    Accept all
                  </button>
                  <button
                    onClick={handleReject}
                    type="button"
                    className="text-sm/6 font-semibold text-gray-900 hover:text-gray-700"
                  >
                    Reject all
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      </main>

      <Footer pathname={location.pathname} />
    </>
  );
}
